import { render } from "./Update.page.vue?vue&type=template&id=2d7b6ba4"
import script from "./Update.page.vue?vue&type=script&lang=js"
export * from "./Update.page.vue?vue&type=script&lang=js"

import "./Update.page.vue?vue&type=style&index=0&id=2d7b6ba4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
